(function() {
  function initHero(hero) {
    if (!hero || hero.dataset.pawdHeroInit === 'true') return;

    const wrap = hero.querySelector('.slides-wrap');
    if (!wrap) return;

    wrap.style.display = 'flex';
    wrap.style.flexWrap = 'nowrap';
    wrap.style.width = '100%';
    wrap.style.maxWidth = '100%';

    const dots = hero.querySelectorAll('.dot');
    const total = wrap.children.length;
    if (!total) return;

    Array.from(wrap.children).forEach(function(slide) {
      slide.style.minWidth = '100%';
      slide.style.maxWidth = '100%';
      slide.style.width = '100%';
      slide.style.flex = '0 0 100%';
      slide.style.flexShrink = '0';
    });

    let current = 0;
    let timer = null;
    const autoplay = hero.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(hero.dataset.autoplaySpeed || '6000', 10);

    function go(index) {
      current = ((index % total) + total) % total;
      wrap.style.transform = 'translate3d(-' + current * 100 + '%, 0, 0)';
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('active', dotIndex === current);
      });
    }

    function clearTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function resetTimer() {
      clearTimer();
      if (autoplay && total > 1) {
        timer = setInterval(function() {
          go(current + 1);
        }, autoplaySpeed);
      }
    }

    const nextButton = hero.querySelector('.carousel-next');
    const prevButton = hero.querySelector('.carousel-prev');

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        go(current + 1);
        resetTimer();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        go(current - 1);
        resetTimer();
      });
    }

    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        go(index);
        resetTimer();
      });
    });

    go(0);
    resetTimer();
    hero.dataset.pawdHeroInit = 'true';
  }

  function initAllHeroes(root) {
    (root || document).querySelectorAll('.hero[id^="hero-"]').forEach(initHero);
  }

  window.PawdHeroInit = initAllHeroes;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllHeroes(document);
    });
  } else {
    initAllHeroes(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllHeroes(event.target);
  });
})();